import React, {useContext, useCallback, useMemo} from 'react';

import {OrderContext} from 'views/order/OrderForm';

import {RadioButton, Input, TextArea, Checkbox} from 'views/FormElements';

import AppUtil from 'AppUtil';
import AppConstants from 'AppConstants';

const DELIVERY_LOCATION_TYPE = AppConstants.DELIVERY_LOCATION_TYPE;
const OUTSIDE_KTM_VALLEY = DELIVERY_LOCATION_TYPE.OUTSIDE_KTM_VALLEY;
const INSIDE_KTM_VALLEY = DELIVERY_LOCATION_TYPE.INSIDE_KTM_VALLEY;

const INSIDE_RING_ROAD = DELIVERY_LOCATION_TYPE.INSIDE_RING_ROAD;
const OUTSIDE_RING_ROAD = DELIVERY_LOCATION_TYPE.OUTSIDE_RING_ROAD;

const DELIVERY_TYPE = AppConstants.DELIVERY_TYPE;

const styles = {
	regularDeliveryInfo: {color: 'gray', fontSize: '90%'},
	extraCostInfo: {color: '#2e292b', marginTop: '10px', background: '#dfdfdf', padding: '5px 10px', borderBottom: "2px solid #f8931c"},
	photoFrameDeliveryInfo: {color: "#2e292b", margin: "10px 0", background: "#dfdfdf", padding: "5px", borderBottom: "2px solid #f8931c"},
}


export const AddressInput = () => {
    const {product, values} = useContext(OrderContext);
    
    const hasOutsideRingroadCharge = product.outsideRingRoadCharge || false;
    const productType = AppConstants.PRODUCT_TYPES[product.productType];

    const isPhotoFrame = product.productType === AppConstants.PRODUCT_TYPES['PHOTO_FRAME'].val;

    const showDeliveryOption = (values.locationType === INSIDE_KTM_VALLEY.val 
        || values.locationType === OUTSIDE_RING_ROAD.val
        || values.locationType === INSIDE_RING_ROAD.val) && !isPhotoFrame;

    const deliveryTime = useMemo(() => AppUtil.getDeliveryTime(product.productType, values.deliveryType), [product, values.deliveryType]);

    return (
        <React.Fragment>
            <div style={{marginTop: '10px'}}>
                <Input label="Street Address: " name="streetAddress" type="text" placeholder="E.g. GopiKrishna Nagar, Chabahil, KTM"/>
            </div>
            <Input label="Phone: " name="phone" type="text" placeholder="E.g. 9862441133"/>
            
            <Input label="Full Name: " name="customerName" type="text" placeholder="E.g. Ram Prasad Koirala"/>
            
            
            <Checkbox name="receiveEmailNotification" label="Send Me Email Notification" />

            {										
                values.receiveEmailNotification &&
                <Input name="customerEmail" placeholder="Enter your email here" type="email" />		
            }

            {
                showDeliveryOption &&

                <div>
                    <h2 style={{color: 'gray'}}>Delivery Option</h2>
                    <div className='flexRow'>
                        <RadioButton style={{flexGrow: '1'}} name="deliveryType" value={DELIVERY_TYPE.REGULAR.val} 
                                    label={DELIVERY_TYPE.REGULAR.label} 
                                    checked={values.deliveryType === DELIVERY_TYPE.REGULAR.val} />
                        
                        <RadioButton style={{flexGrow: '1'}} name="deliveryType" value={DELIVERY_TYPE.IMMEDIATE.val} 
                                    label={DELIVERY_TYPE.IMMEDIATE.label} 
                                    checked={values.deliveryType === DELIVERY_TYPE.IMMEDIATE.val} />
                    </div>

                    {
                        values.deliveryType === DELIVERY_TYPE.REGULAR.val &&
                        <span style={styles.regularDeliveryInfo}>{hasOutsideRingroadCharge? '': 'Free '}Home Delivery within next <b>{deliveryTime}</b>.</span>
                    }

                    {
                        values.deliveryType === DELIVERY_TYPE.IMMEDIATE.val &&

                        <span style={styles.extraCostInfo} className={productType.hasImmediateDelivery? '': 'strikeout'}><b style={{color: '#f49600'}}>Extra Rs. {DELIVERY_TYPE.IMMEDIATE.extraCost}</b> for delivery within <b>{deliveryTime}</b>.</span>
                    }

                    <hr />	
                </div>
            }
            
            <TextArea placeholder={"Extra note for your delivery or any landmark detail (Optional)"}  name="additionalNote" rows="3" />
            {
                isPhotoFrame && 
                <div style={styles.photoFrameDeliveryInfo}>
                    <i className="fa fa-clock-o" style={{color: "rgb(244, 150, 0)" }}aria-hidden="true"></i> Frame takes <b>{deliveryTime}</b> to complete the delivery.
                </div>
            }
        </React.Fragment>
    );
};

const LocationTypeInput = ({prepaymentRequired}) => {
    const {product, values, setFieldValue} = useContext(OrderContext);

    const hasOutsideRingroadCharge = product.outsideRingRoadCharge || false;

    const onInsideKTMValleySelect = useCallback((setFieldValue, locationType) => {
		const deliveryType = AppUtil.getDefaultDeliveryType(product.productType, INSIDE_KTM_VALLEY.val);
		setFieldValue('deliveryType', deliveryType);

        if(!values.paymentPreference && !prepaymentRequired)
		    setFieldValue('paymentPreference', "COD");

		setFieldValue('locationType', locationType.val);
	}, [product, values.paymentPreference]);

	const onOutsideKTMValleySelect = useCallback((setFieldValue) => {
		const deliveryType = AppUtil.getDefaultDeliveryType(product.productType, OUTSIDE_KTM_VALLEY.val);
		setFieldValue('deliveryType', deliveryType);

        if(values.paymentPreference === 'COD')
            setFieldValue('paymentPreference', "");

		setFieldValue('locationType', OUTSIDE_KTM_VALLEY.val);
	}, [product, values.paymentPreference]);


    const locationExtraCost = values.locationType? AppUtil.getLocationExtraCost(values.locationType, product): 0;

    const frameCostInfo = (product && product.productType === AppConstants.PRODUCT_TYPES['PHOTO_FRAME'].val)? "Fragile product requires special handling, hence the added cost.": "";


    return <React.Fragment>
            <label style={{fontSize: '12px', color: 'rgba(0,0,0,.54)', marginBottom: '10px', display: 'block'}}>Where are you located?</label>
            <div className={hasOutsideRingroadCharge? 'flexColumn': 'flexRow'}>
                {
                    !hasOutsideRingroadCharge &&
                    <RadioButton style={{flexGrow: '1'}} name="locationType" value={INSIDE_KTM_VALLEY.val} 
                            label={<span style={{color: '#596161'}}>{INSIDE_KTM_VALLEY.label}</span>} 
                            checked={values.locationType === INSIDE_KTM_VALLEY.val} 
                            onChange={() => onInsideKTMValleySelect(setFieldValue, INSIDE_KTM_VALLEY)}/>
                }

                                    
                {
                    hasOutsideRingroadCharge &&
                    <RadioButton style={{flexGrow: '1'}} name="locationType" value={INSIDE_RING_ROAD.val} 
                                        label={<span style={{color: '#596161'}}>{INSIDE_RING_ROAD.label}</span>} 
                                        checked={values.locationType === INSIDE_RING_ROAD.val} 
                                        onChange={() => onInsideKTMValleySelect(setFieldValue, INSIDE_RING_ROAD)}/>
                }

                {
                    hasOutsideRingroadCharge &&
                    <RadioButton style={{flexGrow: '1'}} name="locationType" value={OUTSIDE_RING_ROAD.val} 
                                    label={<span style={{color: '#596161'}}>{OUTSIDE_RING_ROAD.label}</span>} 
                                    checked={values.locationType === OUTSIDE_RING_ROAD.val} 
                                    onChange={() => onInsideKTMValleySelect(setFieldValue, OUTSIDE_RING_ROAD)} />
                }

                
                <RadioButton style={{flexGrow: '1'}} name="locationType" value={OUTSIDE_KTM_VALLEY.val} 
                                label={<span style={{color: '#596161'}}>{OUTSIDE_KTM_VALLEY.label}</span>} 
                                checked={values.locationType === OUTSIDE_KTM_VALLEY.val} 
                                onChange={() => onOutsideKTMValleySelect(setFieldValue)} />

            </div>
            
            {
                locationExtraCost > 0 &&
                <div>
                    <div style={styles.extraCostInfo}>
                        <b style={{color: '#f49600'}}>Extra Rs. {locationExtraCost}</b> for {DELIVERY_LOCATION_TYPE[values.locationType].label}. {frameCostInfo}
                    </div>
                </div>
            }
        </React.Fragment>
};

export default LocationTypeInput;


// WEBPACK FOOTER //
// ./src/views/order/input/LocationTypeInput.js